import { FunctionsHttpError } from "@supabase/supabase-js";
import { supabase } from "./supabase";

// O aluno cria a senha sem e-mail, depois de o suporte liberar (000383).
//
// Chama a Edge Function `criar-senha-liberada`, que confere e consome a liberação no
// banco e define a senha pela API admin do Auth. Sem sessão: quem chega aqui é quem
// não consegue entrar. A senha em texto só existe nesta chamada e na entrada logo
// depois, que é quando ela vai também para o Memberkit.
export type ResultadoDaSenhaLiberada =
  | { resultado: "ok" }
  | { resultado: "sem_liberacao" }
  | { resultado: "senha_fraca" }
  | { resultado: "pedido_invalido"; detalhe: string }
  | { resultado: "falhou" };

export async function criarSenhaLiberada(email: string, senha: string): Promise<ResultadoDaSenhaLiberada> {
  try {
    const { error } = await supabase.functions.invoke("criar-senha-liberada", {
      body: { email, senha },
    });
    if (!error) return { resultado: "ok" };

    // Em 4xx e 5xx o supabase-js devolve `data: null` e guarda a resposta em
    // `error.context`. É de lá que sai a diferença entre "não há liberação" e
    // "a senha foi recusada", que pedem ações diferentes do aluno.
    if (error instanceof FunctionsHttpError) {
      const status = error.context.status as number;
      let corpo: { erro?: unknown } | null = null;
      try {
        corpo = await error.context.json();
      } catch {
        corpo = null;
      }
      if (corpo?.erro === "sem_liberacao") return { resultado: "sem_liberacao" };
      if (corpo?.erro === "senha_fraca") return { resultado: "senha_fraca" };
      if (status === 400 && typeof corpo?.erro === "string") {
        return { resultado: "pedido_invalido", detalhe: corpo.erro };
      }
    }
    return { resultado: "falhou" };
  } catch {
    return { resultado: "falhou" };
  }
}
